import { defineMessages } from 'react-intl'

export default defineMessages({
  loadingData: {
    id: 'app.progress.loadingData',
    defaultMessage: 'Loading data for {datasource} - {company}',
    description: 'Progress message when loading report data',
  },
  calculatingSubBudget: {
    id: 'app.progress.calculatingSubBudget',
    defaultMessage: 'Calculating {budgetName} - {subBudgetName}',
    description: 'Progress message when calculating sub budget',
  },
  calculatingSubBudgetTarget: {
    id: 'app.progress.calculatingSubBudgetTarget',
    defaultMessage:
      'Calculating {budgetName} - {subBudgetName} dimension target {current}/{total}',
    description:
      'Progress message when calculating sub budget dimension target',
  },
  fetchingInputBalances: {
    id: 'app.progress.fetchingInputBalances',
    defaultMessage: 'Fetching {budgetName} input balances',
    description: 'Progress message when fetching budget input balances',
  },
  fetchingRealBalances: {
    id: 'app.progress.fetchingRealBalances',
    defaultMessage: 'Fetching {budgetName} real balances',
    description: 'Progress message when fetching budget real balances',
  },
  fetchingSubBudgets: {
    id: 'app.progress.fetchingSubBudgets',
    defaultMessage: 'Fetching {budgetName} sub budgets',
    description: 'Progress message when fetching sub budgets',
  },
  importingDimensionTarget: {
    id: 'app.progress.importingDimensionTarget',
    defaultMessage: 'Importing dimension target {current}/{total}',
    description: 'Progress message when importing dimension targets',
  },
  calculatingBudget: {
    id: 'app.progress.calculatingBudget',
    defaultMessage: 'Calculating {budgetName}',
    description: 'Progress message when calculating budget',
  },
  calculatingBudgetTarget: {
    id: 'app.progress.calculatingBudgetTarget',
    defaultMessage:
      'Calculating {budgetName} dimension target {current}/{total}',
    description: 'Progress message when calculating budget dimension target',
  },
  copyingBudget: {
    id: 'app.progress.copyingBudget',
    defaultMessage: 'Copying budget',
    description: 'Progress message when copying a budget',
  },
  copyingBudgetScheme: {
    id: 'app.progress.copyingBudgetScheme',
    defaultMessage: 'Copying budget scheme',
    description: 'Progress message when copying a budget scheme',
  },
  copyingBudgetData: {
    id: 'app.progress.copyingBudgetData',
    defaultMessage: 'Copying budget data',
    description: 'Progress message when copying budget data',
  },
  copyingSubBudgets: {
    id: 'app.progress.copyingSubBudgets',
    defaultMessage: 'Copying sub budgets {current}/{total}',
    description: 'Progress message when copying sub budgets',
  },
})

// Finnish translations
// Note: These should be added to your i18n translation files (e.g., fi.json)
// Example structure for fi.json:
// {
//   "app.progress.loadingData": "Ladataan dataa: {datasource} - {company}",
//   "app.progress.calculatingSubBudget": "Lasketaan {budgetName} - {subBudgetName}",
//   "app.progress.calculatingSubBudgetTarget": "Lasketaan {budgetName} - {subBudgetName} ulottuvuuskohde {current}/{total}",
//   "app.progress.fetchingInputBalances": "Haetaan budjetin {budgetName} syöttösaldot",
//   "app.progress.fetchingRealBalances": "Haetaan budjetin {budgetName} toteumasaldot",
//   "app.progress.fetchingSubBudgets": "Haetaan budjetin {budgetName} alibudjetit",
//   "app.progress.importingDimensionTarget": "Tuodaan ulottuvuuskohdetta {current}/{total}",
//   "app.progress.calculatingBudget": "Lasketaan {budgetName}",
//   "app.progress.calculatingBudgetTarget": "Lasketaan budjetin {budgetName} ulottuvuuskohde {current}/{total}"
// }
